import { render, staticRenderFns } from "./PaymentSettlementKasbonView.vue?vue&type=template&id=88bfef3a"
import script from "./PaymentSettlementKasbonView.vue?vue&type=script&lang=js"
export * from "./PaymentSettlementKasbonView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports